import React from 'react'

const Records = ({headers}) => {


    const formatHeader = (text) => {
        return text
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }
  return (

    <div className="credentials-table">
        <table>
        <tr className="credentials-header">

        {headers.map((item,index)=>(
        <th className="credentials-th" style={{cursor:"pointer"}} key={index}>
        <div className="credentials-table-text">{formatHeader(item)}</div>
        </th>))}
        </tr>
        </table>
    </div>
  )
}

export default Records